// extracted by mini-css-extract-plugin
export default {"popover-wrapper":"inXfG","popoverWrapper":"inXfG","root":"_1-su9"};